(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/deposit-limits-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/deposit-limits-service.js');
'use strict';

const jupiter = svs.core.jupiter;
const logger = svs.accountservicesReact.deposit.depositLimits.logger;
let api = 1;
if (svs.core.detect.feature('ft-its-api-version')) {
  api = 2;
}

const streamlinedJupiterCall = async options => {
  try {
    const {
      response,
      status
    } = await jupiter.callAsync(options);
    return {
      error: status === 'success' ? null : (response === null || response === void 0 ? void 0 : response.error) || 'error',
      data: status === 'success' ? response : null
    };
  } catch (err) {
    logger.info("Error getting ".concat(options.path), err);
    return {
      error: err,
      data: null
    };
  }
};
const getDepositLimitsAsync = async req => {
  const options = {
    method: 'GET',
    path: "/player/".concat(api, "/depositlimits"),
    req
  };
  const {
    data,
    error
  } = await streamlinedJupiterCall(options);
  return {
    data: data === null || data === void 0 ? void 0 : data.limits,
    error
  };
};
svs.accountservicesReact.deposit.depositLimitsService = {
  getDepositLimitsAsync
};

 })(window);